
<div class="row">
  <div class="col table-card">
    <list-controls [pageName]="'AssetSelect'" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filterAssets.length" (onChange)="onListControlsChange($event)">
      <div class="dropdown" [hidden]="disableAll">
        <button class="btn btn-primary dropdown-toggle" id="actionsButton" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
        <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" id="deselectAll" href="javascript:void(0);" (click)="deselectAll()">Deselect All</a><a class="dropdown-item" id="selectAll" href="javascript:void(0);" (click)="selectAll()">Select All</a><a class="dropdown-item" id="selectAllSearch" href="javascript:void(0);" (click)="selectAllVisible()">Select All In Search</a><a class="dropdown-item" id="deselectAllSearch" href="javascript:void(0);" (click)="deselectAllVisible()">Deselect All In Search</a></div>
      </div>
    </list-controls>
    <table class="table table-responsive">
      <thead>
        <tr class="table-header-with-controls">
          <th></th>
          <th>Model & Info</th>
          <th>Friendly Name</th>
          <th [hidden]="hiddenColumnsContainsAll([&quot;assetTag&quot;, &quot;serialNumber&quot;])">Serial Number</th>
          <th [hidden]="hiddenColumns.includes(&quot;mapId&quot;)">Map Id</th>
        </tr>
      </thead>
      <tbody>
        <ng-template ngFor let-asset [ngForOf]="displayAssets" let-i="index">
          <tr>
            <td>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="asset-selection-checkbox-{{asset.id}}" id="asset-selection-checkbox-{{asset.id}}" [(ngModel)]="asset.selectedNew" [disabled]="disableAll || (disableInstalled &amp;&amp; asset.installed)" (change)="updateSelection()">
              </div>
            </td>
            <td *ngIf="asset.type === &quot;asset removal&quot;">
              <div class="row">
                <div class="col"><span class="badge badge-success mr-2" *ngIf="asset.installed">Removed</span><b>Asset Removal:</b><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>Device: {{ asset.model }}</span><b [hidden]="hiddenColumns.includes(&quot;productNumber&quot;)"> ({{ asset.productNumber || 'unknown' }})</b></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;siteName&quot;)">
                <div class="col"><span>Location Name:</span><span> {{ asset.locationName }}</span></div>
                <div class="col"><span>Site Code:</span><span> {{ asset.siteCode }}</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">
                <div class="col"><span [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">Building: {{ asset.building }}</span><span [hidden]="hiddenColumns.includes(&quot;floor&quot;) || !asset.floor"> (Floor: {{ asset.floor }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;orderNumber&quot;) || !asset.orderNumber">
                <div class="col">Order #: {{ asset.orderNumber }}</div>
              </div>
            </td>
            <td *ngIf="asset.type === &quot;asset&quot;">
              <div class="row">
                <div class="col"><span class="badge badge-success mr-2" *ngIf="asset.installed">Installed</span><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>Device: {{ asset.model }}</span><b [hidden]="hiddenColumns.includes(&quot;productNumber&quot;)"> ({{ asset.productNumber }})</b></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;solutionId&quot;)">
                <div class="col">Device Key: {{ asset.deviceKey }}<span class="more_info" *ngIf="asset.originalSolutionKey">(ORIG: {{ asset.originalSolutionKey }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;siteName&quot;)">
                <div class="col-12"><span>Location Name:</span><span> {{ asset.friendlyName }}</span></div>
                <div class="col"><span>Site Code:</span><span> {{ asset.siteCode }}</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">
                <div class="col"><span [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">Building: {{ asset.building }}</span><span [hidden]="hiddenColumns.includes(&quot;floor&quot;) || !asset.floor"> (Floor: {{ asset.floor }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;orderNumber&quot;) || !asset.orderNumber">
                <div class="col">Order #: {{ asset.orderNumber }}</div>
              </div>
              <div class="row" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <div class="col">
                  <label [ngClass]="asset.selectedNew ? &quot;required&quot; : &quot;&quot;">Localization Codes11:</label>
                </div>
              </div>
              <div class="row px-3 w-50" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <ng-template ngFor let-lc [ngForOf]="asset.localizationCodes">
                  <div class="form-check w-50 mb-1">
                    <input class="form-check-input" type="radio" [disabled]="!asset.selectedNew" [name]="&quot;localizationCode &quot;+i" autoLinkToLabel [ngModel]="asset.localizationCodeId" [value]="lc.id" (change)="setLocalizationCode(asset, lc.id)">
                    <label class="form-check-label">{{lc.localizationCode}}</label><br><span class="text-secondary" style="font-size: smaller">{{lc.localizationDescription}}</span>
                  </div>
                </ng-template>
              </div>
            </td>
            <td *ngIf="asset.type === &quot;software&quot;">
              <div class="row">
                <div class="col"><span class="badge badge-success mr-2" *ngIf="asset.installed">Installed</span><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>Software: {{ asset.model }}</span><b [hidden]="hiddenColumns.includes(&quot;productNumber&quot;)"> ({{ asset.productNumber }})</b></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;solutionId&quot;)">
                <div class="col">Device Key: {{ asset.deviceKey }}<span class="more_info" *ngIf="asset.originalSolutionKey">(ORIG: {{ asset.originalSolutionKey }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;siteName&quot;)">
                <div class="col-12"><span>Location Name:</span><span> {{ asset.friendlyName }}</span></div>
                <div class="col"><span>Site Code:</span><span> {{ asset.siteCode }}</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">
                <div class="col"><span [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">Building: {{ asset.building }}</span><span [hidden]="hiddenColumns.includes(&quot;floor&quot;) || !asset.floor"> (Floor: {{ asset.floor }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;orderNumber&quot;) || !asset.orderNumber">
                <div class="col">Order #: {{ asset.orderNumber }}</div>
              </div>
              <div class="row" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <div class="col">
                  <label>Localization Codes (optional):</label>
                </div>
              </div>
              <div class="row px-3 w-50" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <ng-template ngFor let-lc [ngForOf]="asset.localizationCodes">
                  <div class="form-check w-50 mb-1">
                    <input class="form-check-input" type="radio" [disabled]="!asset.selectedNew" [name]="&quot;localizationCode &quot;+i" autoLinkToLabel [ngModel]="asset.localizationCodeId" [value]="lc.id" (change)="setLocalizationCode(asset, lc.id)">
                    <label class="form-check-label">{{lc.localizationCode}}</label><br><span class="text-secondary" style="font-size: smaller">{{lc.localizationDescription}}</span>
                  </div>
                </ng-template>
              </div>
            </td>
            <td *ngIf="asset.type === &quot;accessory&quot;">
              <div class="row">
                <div class="col"><span class="badge badge-success mr-2" *ngIf="asset.installed">Installed</span><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><span>Accessory: {{ asset.model }}</span><b [hidden]="hiddenColumns.includes(&quot;productNumber&quot;)"> ({{ asset.productNumber }})</b></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;solutionId&quot;)">
                <div class="col">Device Key: {{ asset.deviceKey }}<span class="more_info" *ngIf="asset.originalSolutionKey">(ORIG: {{ asset.originalSolutionKey }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;siteName&quot;)">
                <div class="col-12"><span>Location Name:</span><span> {{ asset.friendlyName }}</span></div>
                <div class="col"><span>Site Code:</span><span> {{ asset.siteCode }}</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">
                <div class="col"><span [hidden]="hiddenColumns.includes(&quot;building&quot;) || !asset.building">Building: {{ asset.building }}</span><span [hidden]="hiddenColumns.includes(&quot;floor&quot;) || !asset.floor"> (Floor: {{ asset.floor }})</span></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;orderNumber&quot;) || !asset.orderNumber">
                <div class="col">Order #: {{ asset.orderNumber }}</div>
              </div>
              <div class="row" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <div class="col">
                  <label>Localization Codes (optional):</label>
                </div>
              </div>
              <div class="row px-3 w-50" *ngIf="!disableLocalizations &amp;&amp; asset.localizationCodes.length">
                <ng-template ngFor let-lc [ngForOf]="asset.localizationCodes">
                  <div class="form-check w-50 mb-1">
                    <input class="form-check-input" type="radio" [disabled]="!asset.selectedNew" [name]="&quot;localizationCode &quot;+i" autoLinkToLabel [ngModel]="asset.localizationCodeId" [value]="lc.id" (change)="setLocalizationCode(asset, lc.id)">
                    <label class="form-check-label">{{lc.localizationCode}}</label><br><span class="text-secondary" style="font-size: smaller">{{lc.localizationDescription}}</span>
                  </div>
                </ng-template>
              </div>
            </td>
            <td>{{ asset.deviceFriendlyName }}</td>
            <td [hidden]="hiddenColumnsContainsAll([&quot;assetTag&quot;, &quot;serialNumber&quot;])">
              <div class="row" [hidden]="hiddenColumns.includes(&quot;serialNumber&quot;)">
                <div class="col">{{ asset.serialNumber }}</div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;assetTag&quot;) || !asset.assetTag">
                <div class="col">Asset Tag: {{ asset.assetTag }}</div>
              </div>
            </td>
            <td [hidden]="hiddenColumns.includes(&quot;floorMapId&quot;)">{{ asset.floorMapId }}</td>
          </tr>
          <tr class="no-top-border no-top-padding" *ngFor="let solution of asset.children; let j = index">
            <td></td>
            <td>
              <div class="row">
                <div class="col"><span class="badge badge-success mr-2" *ngIf="solution.installed">Installed</span><span>{{solution.type === "accessory" ? "Accessory": "Software"}}: {{ solution.model }}</span><b> ({{ solution.productNumber }})</b></div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;solutionId&quot;) || !solution.deviceKey">
                <div class="col">Device Key: {{ solution.deviceKey }}</div>
              </div>
              <div class="row" *ngIf="!disableLocalizations &amp;&amp; solution.localizationCodes.length">
                <div class="col">
                  <label>Localization Codes (optional):</label>
                </div>
              </div>
              <div class="row px-3 w-50" *ngIf="!disableLocalizations &amp;&amp; solution.localizationCodes.length">
                <ng-template ngFor let-lc [ngForOf]="solution.localizationCodes">
                  <div class="form-check w-50 mb-1">
                    <input class="form-check-input" type="radio" [disabled]="!solution.selectedNew" [name]="&quot;localizationCode &quot;+j" autoLinkToLabel [ngModel]="solution.localizationCodeId" [value]="lc.id" (change)="setLocalizationCode(solution, lc.id)">
                    <label class="form-check-label">{{lc.localizationCode}}</label><br><span class="text-secondary" style="font-size: smaller">{{lc.localizationDescription}}</span>
                  </div>
                </ng-template>
              </div>
            </td>
            <td [hidden]="hiddenColumnsContainsAll([&quot;assetTag&quot;, &quot;serialNumber&quot;])">
              <div class="row" [hidden]="hiddenColumns.includes(&quot;serialNumber&quot;)">
                <div class="col">{{ solution.serialNumber }}</div>
              </div>
              <div class="row" [hidden]="hiddenColumns.includes(&quot;assetTag&quot;) || !solution.assetTag">
                <div class="col">Asset Tag: {{ solution.assetTag }}</div>
              </div>
            </td>
            <td></td>
          </tr>
        </ng-template>
        <tr *ngIf="assets.length === 0">
          <td [attr.colspan]="hideSerialNumberAndAssetNumber ? 7 : 9">
            <p class="text-center empty-table-message">There are no assets to display.</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>